import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";

export function isTokenExpired(response) {
  if (response.status === 401 || response.status === 403) {
    const jwt = secureLocalStorage.getItem("user");
    const decoded = jwtDecode(jwt);
    const exp = dayjs(decoded["exp"] * 1000);
    if (dayjs().isAfter(exp)) {
      secureLocalStorage.removeItem("user");
      // eslint-disable-next-line no-restricted-globals
      location.reload(true);
    }
    return { message: 403 };
  }
  return response;
}
